import { render, staticRenderFns } from "./ApiActionsCheckBoxes.vue?vue&type=template&id=0156c5bc"
import script from "./ApiActionsCheckBoxes.vue?vue&type=script&lang=ts"
export * from "./ApiActionsCheckBoxes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports